/** Dynamic load of geng-mpc-client WASM (built into `web/public/mpc/pkg/`). */

export type MpcWasmModule = {
  default: (moduleOrPath?: RequestInfo | URL | WebAssembly.Module) => Promise<void>;
  wasm_keygen_prepare: (paillierBits: number) => string;
  wasm_keygen_finalize: (respJson: string, clientSecretJson: string) => string;
  wasm_import_prepare: (secretHex: string, paillierBits: number) => string;
  wasm_import_finalize: (respJson: string, clientSecretJson: string) => string;
  wasm_sign_round1: (zHex: string) => string;
  /** `z` is only in `signRound1Json`; do not pass a separate digest. */
  wasm_sign_complete: (sessionJson: string, signRound1Json: string, round2Json: string) => string;
};

let modPromise: Promise<MpcWasmModule> | null = null;

export async function loadMpcWasm(): Promise<MpcWasmModule> {
  if (!modPromise) {
    modPromise = import('@cointrader/mpc-wasm').then(async (m) => {
      await m.default();
      return m;
    });
  }
  return modPromise;
}

export type KeygenPrepareOut = {
  keygen_request: { p1_hex: string; n_hex: string; c_key_hex: string };
  client_secret: {
    d1_hex: string;
    paillier_n_hex: string;
    paillier_lambda_hex: string;
    paillier_mu_hex: string;
  };
};

export type ImportPrepareOut = {
  import_request: { p1_hex: string; d2_hex: string; n_hex: string; c_key_hex: string };
  client_secret: KeygenPrepareOut['client_secret'];
};
